module.exports = __webpack_public_path__ + "assets/img/home-zgyh.6d0a7d2f.png";